
export const galleryCategories = [
  'Wszystkie',
  'Konstrukcje Stalowe',
  'Spawalnictwo',
  'Obróbka CNC',
  'Energetyka',
  'Infrastruktura',
];

export const galleryProjects = [
  {
    id: 1,
    title: 'Konstrukcja Hali Przemysłowej',
    category: 'Konstrukcje Stalowe',
    description: 'Kompleksowa realizacja hali o rozpiętości 48m dla zakładu produkcyjnego w Rzeszowie. Konstrukcja nośna z profili HEB i IPE.',
    year: '2024',
    client: 'Zakłady Metalurgiczne Rzeszów',
    weight: '186 ton',
    image: 'https://public.readdy.ai/ai/img_res/d367290ad2dd79820d853af799898bf0.jpg',
    featured: true,
  },
  {
    id: 2,
    title: 'Rurociąg Wysokociśnieniowy DN600',
    category: 'Spawalnictwo',
    description: 'Spawanie rurociągu wysokociśnieniowego DN600 ze stali P91 metodą TIG/MIG dla elektrowni cieplnej.',
    year: '2024',
    client: 'PGE Energia Ciepła',
    weight: '42 tony',
    image: 'https://readdy.ai/api/search-image?query=high%20pressure%20industrial%20pipeline%20welding%20with%20bright%20blue%20electric%20arc%20sparks%20in%20dark%20factory%20environment%20close%20up%20precision%20TIG%20welding%20on%20large%20diameter%20steel%20pipe%20photorealistic%208k%20cinematic%20no%20text%20no%20logo&width=800&height=1000&seq=gallery-002&orientation=portrait',
    featured: false,
  },
  {
    id: 3,
    title: 'Wały Napędowe Turbiny',
    category: 'Obróbka CNC',
    description: 'Precyzyjna obróbka CNC wałów napędowych o długości 3.2m z tolerancją 0.01mm dla turbiny parowej.',
    year: '2023',
    client: 'Siemens Energy',
    weight: '8.5 tony',
    image: 'https://readdy.ai/api/search-image?query=CNC%20lathe%20machine%20precision%20turning%20large%20steel%20shaft%20with%20blue%20coolant%20spray%20macro%20shot%20industrial%20manufacturing%20photorealistic%208k%20quality%20dark%20moody%20atmosphere%20metallic%20reflections%20no%20text%20no%20logo&width=800&height=600&seq=gallery-003&orientation=landscape',
    featured: false,
  },
  {
    id: 4,
    title: 'Most Technologiczny Elektrowni',
    category: 'Energetyka',
    description: 'Projekt i wykonanie mostu technologicznego o długości 120m łączącego bloki energetyczne elektrowni.',
    year: '2023',
    client: 'TAURON Wytwarzanie',
    weight: '320 ton',
    image: 'https://readdy.ai/api/search-image?query=massive%20industrial%20technological%20bridge%20connecting%20power%20plant%20buildings%20at%20night%20with%20dramatic%20blue%20atmospheric%20lighting%20steel%20construction%20photorealistic%20cinematic%208k%20quality%20dark%20sky%20industrial%20landscape%20no%20text%20no%20logo&width=800&height=1000&seq=gallery-004&orientation=portrait',
    featured: true,
  },
  {
    id: 5,
    title: 'Estakada Rurociągowa',
    category: 'Infrastruktura',
    description: 'Wykonanie i montaż estakady rurociągowej o długości 280m dla zakładu petrochemicznego.',
    year: '2024',
    client: 'PKN Orlen',
    weight: '210 ton',
    image: 'https://readdy.ai/api/search-image?query=industrial%20pipe%20rack%20steel%20structure%20at%20petrochemical%20plant%20twilight%20with%20blue%20atmospheric%20lighting%20long%20perspective%20view%20photorealistic%20cinematic%208k%20quality%20dramatic%20sky%20industrial%20architecture%20no%20text%20no%20logo&width=800&height=600&seq=gallery-005&orientation=landscape',
    featured: false,
  },
  {
    id: 6,
    title: 'Zbiornik Ciśnieniowy 50m3',
    category: 'Spawalnictwo',
    description: 'Wykonanie zbiornika ciśnieniowego o pojemności 50m3 ze stali nierdzewnej 316L z pełną dokumentacją UDT.',
    year: '2023',
    client: 'Grupa Azoty',
    weight: '18 ton',
    image: 'https://readdy.ai/api/search-image?query=large%20stainless%20steel%20pressure%20vessel%20being%20welded%20in%20industrial%20workshop%20with%20blue%20welding%20light%20reflections%20on%20polished%20metal%20surface%20photorealistic%208k%20cinematic%20quality%20dark%20environment%20no%20text%20no%20logo&width=800&height=600&seq=gallery-006&orientation=landscape',
    featured: false,
  },
  {
    id: 7,
    title: 'Konstrukcja Wieży Chłodniczej',
    category: 'Konstrukcje Stalowe',
    description: 'Realizacja konstrukcji stalowej wieży chłodniczej o wysokości 45m dla zakładu chemicznego.',
    year: '2022',
    client: 'CIECH Soda Polska',
    weight: '156 ton',
    image: 'https://readdy.ai/api/search-image?query=industrial%20cooling%20tower%20steel%20framework%20construction%20at%20night%20with%20dramatic%20blue%20uplighting%20massive%20scale%20industrial%20architecture%20photorealistic%20cinematic%208k%20quality%20dark%20atmosphere%20fog%20effects%20no%20text%20no%20logo&width=800&height=1000&seq=gallery-007&orientation=portrait',
    featured: true,
  },
  {
    id: 8,
    title: 'Elementy Kotła Parowego',
    category: 'Obróbka CNC',
    description: 'Precyzyjna obróbka elementów kotła parowego - kołnierze, tuleje i pierścienie uszczelniające.',
    year: '2024',
    client: 'Rafako S.A.',
    weight: '12 ton',
    image: 'https://readdy.ai/api/search-image?query=precision%20machined%20steel%20flanges%20and%20rings%20for%20steam%20boiler%20arranged%20on%20industrial%20workbench%20with%20dramatic%20blue%20side%20lighting%20macro%20detail%20shot%20photorealistic%208k%20quality%20dark%20background%20metallic%20textures%20no%20text%20no%20logo&width=800&height=600&seq=gallery-008&orientation=landscape',
    featured: false,
  },
  {
    id: 9,
    title: 'Podesty i Platformy Serwisowe',
    category: 'Infrastruktura',
    description: 'Kompleksowy system podestów serwisowych i platform obsługowych dla bloku energetycznego 200MW.',
    year: '2023',
    client: 'Enea Wytwarzanie',
    weight: '95 ton',
    image: 'https://readdy.ai/api/search-image?query=industrial%20service%20platforms%20and%20walkways%20inside%20power%20plant%20with%20blue%20safety%20lighting%20steel%20grating%20and%20handrails%20dramatic%20perspective%20photorealistic%20cinematic%208k%20quality%20dark%20industrial%20interior%20no%20text%20no%20logo&width=800&height=600&seq=gallery-009&orientation=landscape',
    featured: false,
  },
  {
    id: 10,
    title: 'Kratownica Dachowa 60m',
    category: 'Konstrukcje Stalowe',
    description: 'Wykonanie i montaż kratownicy dachowej o rozpiętości 60m dla centrum logistycznego.',
    year: '2024',
    client: 'Amazon Logistics',
    weight: '240 ton',
    image: 'https://readdy.ai/api/search-image?query=massive%20steel%20roof%20truss%20structure%20being%20assembled%20with%20crane%20at%20construction%20site%20twilight%20blue%20hour%20dramatic%20lighting%20industrial%20scale%20photorealistic%20cinematic%208k%20quality%20wide%20angle%20no%20text%20no%20logo&width=800&height=600&seq=gallery-010&orientation=landscape',
    featured: true,
  },
  {
    id: 11,
    title: 'Instalacja Odpylania',
    category: 'Energetyka',
    description: 'Wykonanie i montaż konstrukcji stalowej instalacji odpylania spalin dla bloku 500MW.',
    year: '2022',
    client: 'PGE GiEK',
    weight: '180 ton',
    image: 'https://readdy.ai/api/search-image?query=industrial%20flue%20gas%20desulfurization%20system%20steel%20structure%20at%20power%20plant%20night%20view%20with%20blue%20atmospheric%20lighting%20massive%20industrial%20equipment%20photorealistic%20cinematic%208k%20quality%20dark%20sky%20no%20text%20no%20logo&width=800&height=600&seq=gallery-011&orientation=landscape',
    featured: false,
  },
  {
    id: 12,
    title: 'Korpusy Pomp Przemysłowych',
    category: 'Obróbka CNC',
    description: 'Obróbka CNC korpusów pomp przemysłowych z żeliwa sferoidalnego - seria 24 sztuk.',
    year: '2024',
    client: 'Hydro-Vacuum S.A.',
    weight: '6.8 tony',
    image: 'https://readdy.ai/api/search-image?query=CNC%20milling%20machine%20cutting%20industrial%20pump%20housing%20from%20cast%20iron%20with%20blue%20coolant%20mist%20precision%20manufacturing%20close%20up%20photorealistic%208k%20quality%20dark%20workshop%20environment%20metallic%20chips%20flying%20no%20text%20no%20logo&width=800&height=1000&seq=gallery-012&orientation=portrait',
    featured: false,
  },
];
